import {CountryDto} from "@esa/api";
import {createReducer, on} from "@ngrx/store";
import {CountriesActions} from "../actions";

export const countriesFeatureKey = 'countries';

export interface CountriesState {
  countries: CountryDto[];
}

export const initialState: CountriesState = {
  countries: [],
}

export const countriesReducer = createReducer(
  initialState,
  on(CountriesActions.getCountriesSuccess, (state, { countries }) => ({ ...state, countries }))
)
